import { useMutation, useQueryClient } from 'react-query';

import { invitationsApi } from 'src/Services/API';

export const useResendInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (invitationId: string) => {
      return invitationsApi.invitationsControllerResend(invitationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-members']);
    },
  });
};
